<template>
    <form-row title="Were Lawyers Sent Closing Info?">
        <div class="flex items-center">
            <div class="flex items-center mt-4 mb-3">
                <input-radio-boolean
                    name="buyer_lawyers_sent_closing_info"
                    v-model="buyer_lawyers_sent_closing_info"
                    true="Yes"
                    false="No"
                    class="ml-0"
                    :read_only="read_only"
                />
            </div>

            <div v-if="buyer_lawyers_sent_closing_info" class="flex-1 -mt-4 ml-6">
                <input-date
                    label="Sent at"
                    name="buyer_lawyers_sent_closing_info_date"
                    :value="deal.buyer_lawyers_sent_closing_info_date"
                    :read_only="read_only"
                />
            </div>
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        deal: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            buyer_lawyers_sent_closing_info: this.deal.buyer_lawyers_sent_closing_info,
        }
    },
}
</script>
